import { ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { pathways, utilityLinks } from '../data/site';
import { ReviewTeaser } from './ReviewTeaser';
import { SiteLink } from './SiteLink';
export function Pathways() {
  return <section aria-labelledby="pathways-heading" className="w-full bg-white" data-id="element-278" data-mp="753tbtnnc94d">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-279" data-mp="b78fk7brm3gz">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between lg:gap-12" data-id="element-280" data-mp="3tdd4akwtcaaq">
          <div className="min-w-0 lg:max-w-2xl" data-id="element-281" data-mp="27256ubd5jm1">
            <h2 id="pathways-heading" className="text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-282" data-mp="27v9zpqrhz1j">
              Everything You Need to Enjoy the Backyard More
            </h2>
            <p className="mt-3 text-body text-ink/80 sm:text-body-lg" data-id="element-283" data-mp="3ogcy89zyr7jm">
              Start with what brings you here.
            </p>
          </div>

          <ReviewTeaser className="w-full lg:w-[360px] lg:shrink-0" data-id="element-284" data-mp="1mn6toplsvfp2" />
        </div>

        {/* Desktop and tablet: 3 + 2 arrangement */}
        <ul className="mt-8 hidden gap-5 sm:grid sm:grid-cols-2 lg:grid-cols-6" data-id="element-285" data-mp="13k8brtukfln1">
          {pathways.map((pathway, index) => <li key={pathway.title} className={index < 3 ? 'lg:col-span-2' : index === 4 ? 'sm:col-span-2 lg:col-span-3' : 'lg:col-span-3'} data-id="element-286" data-mp="1dbuppxyafyth" data-mpi={index}>
              <SiteLink to={pathway.href} className="group flex h-full flex-col overflow-hidden rounded-card border border-ink/10 bg-white transition-colors duration-150 ease-out hover:border-pegasus-blue" data-id="element-287" data-mp="fo3vi6ufuj2o">
                <div className={index < 3 ? 'aspect-[4/3] w-full' : index === 3 ? 'aspect-[4/3] w-full lg:aspect-[16/9]' : 'aspect-[16/9] w-full'} data-id="element-288" data-mp="plh0ef738e2l">
                  <img src={pathway.image} alt={pathway.alt} className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-289" data-mp="284dihpwigt5q" />
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-290" data-mp="2n0ut2ewvm3r8">
                  <h3 className="text-h3 font-semibold text-ink" data-id="element-291" data-mp="1pe5gjb4js8r4">{pathway.title}</h3>
                  <p className="mt-2 text-[16px] leading-6 text-ink/75" data-id="element-292" data-mp="1pcayq5okowr9">{pathway.description}</p>
                  <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-[15.5px] font-bold text-pegasus-blue group-hover:text-pegasus-magenta" data-id="element-293" data-mp="1uavxs1s39ae4">
                    Explore {pathway.title}
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-294" data-mp="244uzx0s5wu62" />
                  </span>
                </div>
              </SiteLink>
            </li>)}
        </ul>

        {/* Mobile: compact media rows */}
        <ul className="mt-7 divide-y divide-ink/10 border-y border-ink/10 sm:hidden" data-id="element-295" data-mp="3oximu0yh8j5q">
          {pathways.map(pathway => <li key={pathway.title} data-id="element-296" data-mp="3kwqd76lp0c8x">
              <SiteLink to={pathway.href} className="flex items-center gap-4 py-4" data-id="element-297" data-mp="3ktkp9uosvges">
                <img src={pathway.image} alt={pathway.alt} className="h-[76px] w-[100px] shrink-0 rounded-card object-cover" loading="lazy" decoding="async" data-id="element-298" data-mp="3fyf3qwzb83r8" />
                <span className="min-w-0 flex-1" data-id="element-299" data-mp="316d6zlsjdqvf">
                  <span className="block text-[18px] font-semibold text-ink" data-id="element-300" data-mp="315lewky5eb9w">{pathway.title}</span>
                  <span className="mt-1 block text-[15px] leading-5 text-ink/75" data-id="element-301" data-mp="2x3godv2zxurh">
                    {pathway.description}
                  </span>
                </span>
                <ChevronRightIcon className="h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-302" data-mp="2n6vfgynuvzid" />
              </SiteLink>
            </li>)}
        </ul>

        <ul className="mt-7 flex flex-col gap-x-8 gap-y-1 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-303" data-mp="m7rttesql700">
          {utilityLinks.map(link => <li key={link.label} data-id="element-304" data-mp="cgdzrmjk0ze9">
              <SiteLink to={link.href} className="inline-flex min-h-[44px] items-center gap-1.5 text-[16px] font-medium text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta hover:decoration-pegasus-magenta" data-id="element-305" data-mp="cfcd0kt6eogp">
                {link.label}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-306" data-mp="3pn7ct5j3eqxa" />
              </SiteLink>
            </li>)}
        </ul>
      </div>
    </section>;
}